import { render, staticRenderFns } from "./ParentReferences.vue?vue&type=template&id=2db7328d&scoped=true&"
import script from "./ParentReferences.vue?vue&type=script&lang=js&"
export * from "./ParentReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7328d",
  null
  
)

export default component.exports